import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { Amplify } from 'aws-amplify'

import { addLanguage } from './presentation/adapters/translate/translate'
import { GlobalStyle } from './presentation/styles/global'
import Routes from './presentation/components/routes'
import amplifyConfig from './main/configs/aws-exports.js'
import 'react-tooltip/dist/react-tooltip.css'

addLanguage('pt_BR')
Amplify.configure(amplifyConfig)

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <GlobalStyle />
      <Routes />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
)
